var React = require('react');

function IconDownload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 2V0H9V2H7ZM7 4H9V14.5858L14.2929 9.29289L15.7071 10.7071L8 18.4142L0.292893 10.7071L1.70711 9.29289L7 14.5858V4ZM16 20V22H0V20H16Z","fill":"#170F4F"}));
}

IconDownload.defaultProps = {"width":"16","height":"22","viewBox":"0 0 16 22","fill":"none"};

module.exports = IconDownload;

IconDownload.default = IconDownload;
